export default __webpack_public_path__ + "img_220720_AWE_main_s_fullcolor_rgb.svg";